var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSettings(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.488 2.813c6.314 0 9.012 2.697 9.012 9.011v6.977c0 6.314-2.698 9.012-9.012 9.012h-6.976c-6.314 0-9.012-2.698-9.012-9.012v-6.977c0-6.314 2.698-9.011 9.012-9.011h6.976z",
    fill: "#282D61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.538 23.195V18.68c0-.475.425-.868.937-.868.513 0 .938.393.938.868v4.514c0 .474-.425.868-.938.868-.512 0-.937-.394-.937-.868zM18.538 9.312V6.875c0-.513.425-.938.937-.938.513 0 .938.425.938.938v2.437a.944.944 0 0 1-.938.938.944.944 0 0 1-.937-.938z",
    fill: "#FFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.538 14a3.125 3.125 0 0 1 6.25 0 3.131 3.131 0 0 1-3.125 3.125A3.125 3.125 0 0 1 16.538 14zm1.4 0c0 .952.774 1.726 1.725 1.726.952 0 1.726-.774 1.726-1.726 0-.951-.784-1.726-1.726-1.726-.951 0-1.726.775-1.726 1.726z",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.587 23.125v-2.438c0-.512.425-.937.938-.937.512 0 .937.425.937.937v2.438a.936.936 0 0 1-.937.937.944.944 0 0 1-.938-.937zM9.587 10.243V6.632c0-.38.425-.694.938-.694.512 0 .937.314.937.694v3.611c0 .38-.412.694-.937.694-.513 0-.938-.314-.938-.694z",
    fill: "#FFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.5 15.625a3.125 3.125 0 1 1 6.25 0 3.125 3.125 0 0 1-6.25 0zm1.4 0c0 .951.774 1.726 1.725 1.726.951 0 1.726-.775 1.726-1.726s-.765-1.726-1.726-1.726c-.951 0-1.726.775-1.726 1.726z",
    fill: "#FFF"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettings);
export default __webpack_public_path__ + "static/media/settings.cfc9845f460fe51682a4e57c1fb525c6.svg";
export { ForwardRef as ReactComponent };